<script setup lang="ts">
import StatBlock from "@/components/modules/Analytics/Charts/StatBlock.vue";
import DynamicByMonth from "@/components/modules/Analytics/Charts/DynamicByMonth.vue";
import RegionTop from "@/components/modules/Analytics/Charts/RegionTop.vue";
import {ReturnedCasesAnalyticProps} from "@/types/analytics";

defineProps<ReturnedCasesAnalyticProps>();
</script>

<template>
  <div class="params">
    <div class="params__wrapper">
      <StatBlock
        title="возвращено дел прокурором и судом"
        :value="analyticData.totalData?.total_returned?.value"
        :percent="analyticData.totalData?.total_returned?.percent_to_previous"
        :is-appg="false"
        :is-main="true"
      />
      <StatBlock
        title="удельный вес от направленных прокурору"
        :value="analyticData.totalData?.percent_returned_to_prosecutor?.value"
        :percent="analyticData.totalData?.percent_returned_to_prosecutor?.percent_to_previous"
        :is-appg="true"
      />
      <StatBlock
        title="возвращено прокурором"
        :value="analyticData.totalData?.returned_by_prosecutor?.value"
        :percent="analyticData.totalData?.returned_by_prosecutor?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="удельный вес от числа возвращенных"
        :value="analyticData.totalData?.percent_returned_by_prosecutor?.value"
        :percent="analyticData.totalData?.percent_returned_by_prosecutor?.percent_to_previous"
        :is-appg="true"
      />
      <StatBlock
        title="с постановлением об отказе в судебном штрафе"
        :value="analyticData.totalData?.returned_by_court_with_fine_refusal?.value"
        :percent="analyticData.totalData?.returned_by_court_with_fine_refusal?.percent_to_previous"
        :is-appg="false"
      />
      <StatBlock
        title="удельный вес от направленных в суд"
        :value="analyticData.totalData?.percent_returned_by_court?.value"
        :percent="analyticData.totalData?.percent_returned_by_court?.percent_to_previous"
        :is-appg="true"
      />
    </div>

    <DynamicByMonth
      :active-type="activeType"
      :selected-region="selectedRegion"
      :selected-district="selectedDistrict"
      :dynamic="analyticData.monthlyDynamic"
    />
    <template v-if="activeType !== 'region'">
      <RegionTop
        sort-order="desc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topDescending"
      />
      <RegionTop
        sort-order="asc"
        :active-type="activeType"
        :selected-district="selectedDistrict"
        :region-list="analyticData.topAscending"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.params {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    margin-top: auto;
  }
}
</style>